import { useState } from "react";
import MFAOptions from "./MFAOptions";
import { Modal } from "shared/components/common/Modal";
import { Button } from "shared/components/Button";

const MFAModalComponent = ({
  modalIsOpen,
  handleToggleModal,
  setModalIsOpen,
  handleRadioChange,
}) => {
  const [modalSelectedValue, setModalSelectedValue] = useState(
    MFAOptions.AUTHENTICATOR_APP.value
  );
  return (
    <Modal
      open={modalIsOpen}
      onToggle={handleToggleModal}
      style={{}}
      closeIcon
      contentProps={{
        style: {
          padding: "50px 60px",
        },
      }}
    >
      <b>Choose your preferred MFA method</b>
      <hr />
      Your account requires multi-factor authentication. We have two options,
      but we prefer Google Authenticator, which you can read about{" "}
      <a href="https://en.wikipedia.org/wiki/Google_Authenticator">here</a>.
      <br />
      <br />
      <label>
        <input
          type="radio"
          name="modalMFA"
          value={MFAOptions.AUTHENTICATOR_APP.value}
          checked={modalSelectedValue === MFAOptions.AUTHENTICATOR_APP.value}
          onChange={() =>
            setModalSelectedValue(MFAOptions.AUTHENTICATOR_APP.value)
          }
        />{" "}
        <b>Authenticator App</b>
      </label>
      <br />
      <ol>
        <li>
          Choose the <b>Authenticator App</b> option and click "Submit".
        </li>
        <li>Install the Google Authenticator App on your mobile device.</li>
        <li>
          Add our profile using the plus button inside the app. That will allow
          you to scan the QR code shown in the next step after clicking submit.
        </li>
        <li>Enter the code shown in the app in the next step.</li>
        <li>
          You will then be prompted to use this form of multi-factor
          authentication every time you login to QBench.
        </li>
      </ol>
      <label>
        <input
          type="radio"
          name="modalMFA"
          value={MFAOptions.Email.value}
          checked={modalSelectedValue === MFAOptions.Email.value}
          onChange={() => setModalSelectedValue(MFAOptions.Email.value)}
        />{" "}
        <b>Email</b>
      </label>
      <br />
      <ol>
        <li>
        Choose <b>Email</b> option and click "Submit".
        </li>
        <li>You will recieve a code in your email.</li>
        <li>Enter that code in the next step.</li>
        <li>
          You will then be prompted to use this form of multi-factor
          authentication every time you login to QBench.
        </li>
      </ol>
      <hr />
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          className="bg-secondary border-secondary"
          style={{
            width: "10%",
            height: "44px",
            color: "white",
            textAlign: "center",
          }}
          onClick={() => {
            setModalIsOpen(false);
          }}
        >
          Close
        </Button>
        <Button
          className="bg-primary border-primary"
          style={{
            width: "15%",
            height: "44px",
            color: "white",
          }}
          onClick={() => {
            setModalIsOpen(false);
            handleRadioChange(modalSelectedValue);
          }}
        >
          Submit
        </Button>
      </div>
    </Modal>
  );
};

export default MFAModalComponent;
